import React from 'react';
import { BasicTextArea } from '../../basic-inputs';
import { TooltipPosition, TooltipSize } from '../../tooltip';
import FormField from '../FormField';
import { FormFieldProps } from '../types';

interface TextAreaProps {
  rows?: number;
  error?: boolean;
  errorMessage?: string;
  helpText?: string;
  helpTextPosition?: 'after-label' | 'below-field';
  helperTextToolTipConfig?: {
    size?: TooltipSize;
    position?: TooltipPosition;
  };
  disabled?: boolean;
  placeholder?: string;
  label?: string;
  required?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
}

type Props = FormFieldProps & TextAreaProps;

type TextAreaFieldProps =
  | ({ name: string } & TextAreaProps)
  | ({ name: string } & TextAreaProps & FormFieldProps);

const TextArea: React.FC<Props> = props => {
  const {
    label,
    required,
    disabled,
    error,
    errorMessage,
    placeholder,
    rows,
    helpText,
    helpTextPosition,
    helperTextToolTipConfig,
    onBlur,
    onChange,
    form,
    field
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    form.handleChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    form.handleBlur(e);
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <BasicTextArea
      label={label}
      required={required}
      error={error}
      errorMessage={errorMessage}
      helpText={helpText}
      helpTextPosition={helpTextPosition}
      helperTextToolTipConfig={helperTextToolTipConfig}
      rows={rows}
      placeholder={placeholder}
      disabled={disabled}
      name={field.name}
      value={field.value}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
};

const TextAreaField: React.FC<TextAreaFieldProps> = props => (
  <FormField component={TextArea} {...props} />
);

export default TextAreaField;
